import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { LocalizeNameSpaceTypes } from '@gov-nx/core/service';
import { icValidator } from './Validator/ic';

interface IcNumberShapeRequired extends IcNumberShape {
	isRequired: true;
}

interface IcNumberShapeOptional extends IcNumberShape {
	isRequired?: false;
}

interface IcNumberShape {
	isRequiredMessage?: string;
	isInvalidMessage?: string;
}

export const useIcNumberShape = () => {
	const { t } = useTranslation([LocalizeNameSpaceTypes.Form]);

	function getIcNumberShape(
		props: IcNumberShapeOptional
	): yup.StringSchema<string | undefined>;
	function getIcNumberShape(
		props: IcNumberShapeRequired
	): yup.StringSchema<string>;
	function getIcNumberShape({
		isInvalidMessage,
		isRequiredMessage,
		isRequired,
	}: IcNumberShapeOptional | IcNumberShapeRequired) {
		const schema = yup
			.string()
			.test(
				'length',
				isInvalidMessage ?? t('ico.validace.ic-neni-ve-spravnem-tvaru') ?? {},
				icValidator
			);

		if (isRequired) {
			return schema.required(
				isRequiredMessage ?? t('ico.validace.zadejte-ic') ?? undefined
			);
		}

		return schema;
	}

	return {
		getIcNumberShape,
	};
};
